<template>
    <div v-show="visible">
        <el-dialog title="人员详情" :visible.sync="visible" v-loading="loading" :close-on-click-modal="false" :before-close="dialogClose"  width="950px"> 
            <div style="">
                <div style=" margin-bottom:10px;font-weight:bold;">基本信息：</div>
                <table style="width: 100%; font-weight: 300;font-size: 14px;">
                    <tr>
                        <td width="155px" style="background-color: #F6F7FB;">
                            工号：
                        </td>
                        <td class="pricrTd" width="280px">{{this.form.username?this.form.username:"无"}}</td>
                         <td width="155px" style="background-color: #F6F7FB;">
                            姓名：
                        </td>
                        <td class="pricrTd" width="280px">{{this.form.name?this.form.name:"无"}}</td>
                        <td width="155px" style="background-color: #F6F7FB;">
                            人员类型：
                        </td>
                        <td class="pricrTd" width="100px">{{this.form.personType?this.form.personType:"无"}}</td>
                        <td width="155px" rowspan="3" style="text-align:center;">
                            <el-upload 
                                class="avatar-uploader"
                                :action="uploadUrl"
                                :disabled="isUploadImage"
                                :show-file-list="false"
                                :auto-upload="true"
                                :on-success="handleAvatarSuccess"
                                :before-upload="beforeAvatarUpload">
                                <img v-if="imageUrl" :src="imageUrl" :style="{transform:'rotateZ('+deg+'deg)'}" class="avatar">
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                            <span style="font-size:12px;color:red">(温馨提示：如果遇到照片倒向，请另存图片到本地，再通过本地旋转正常再进行上传。)</span>
                            <!-- <el-button round  @click="rotate" style="width:120px;">旋转</el-button> -->
                            <!-- 点击时旋转90度 -->
                        </td>
                    </tr>

                    <tr>
                        <td width="155px" style="background-color: #F6F7FB;">
                            角色：
                        </td>
                        <td class="pricrTd" width="280px">{{this.form.roleId?this.form.roleId:"无"}}</td>
                         <td width="155px" style="background-color: #F6F7FB;">
                            部门：
                        </td>
                        <td class="pricrTd" width="280px">{{this.form.deptId?this.form.deptId:"无"}}</td>
                        <td width="155px" style="background-color: #F6F7FB;">
                            性别：
                        </td>
                        <td class="pricrTd" width="160px">{{this.form.sex?this.form.sex:"无"}}</td> 
                    </tr>

                    <tr>
                        <td width="155px" style="background-color: #F6F7FB;">
                            身份证：
                        </td>
                        <td class="pricrTd" width="280px">{{this.form.identityCard}}</td>
                         <td width="155px" style="background-color: #F6F7FB;">
                            状态：
                        </td>
                        <td class="pricrTd" width="280px">{{this.form.status}}</td>
                        <td width="155px" style="background-color: #F6F7FB;">
                            岗位：
                        </td>
                        <td class="pricrTd" width="160px">{{this.form.postId?this.form.postId:"无"}}</td>
                    </tr>

                    <tr>
                        <td width="155px" style="background-color: #F6F7FB;">
                            职责描述：
                        </td>
                        <td class="pricrTd" width="280px">{{this.form.postDescrible?this.form.postDescrible:"无"}}</td>
                        <td width="155px" style="background-color: #F6F7FB;">
                            学生类型：
                        </td>
                        <td class="pricrTd" width="280px">{{this.form.studentType?this.form.studentType:"无"}}</td>
                        <td width="155px" style="background-color: #F6F7FB;">
                            宿舍房间号：
                        </td>
                        <td class="pricrTd" width="160px"> {{this.form.roomNumber?this.form.roomNumber:"无"}}</td>
                    </tr>

                    <tr>
                        <td width="155px" style="background-color: #F6F7FB;">
                            办公室地点：
                        </td>
                        <td class="pricrTd" width="280px">{{this.form.office?this.form.office:"无"}}</td>
                        <td width="155px" style="background-color: #F6F7FB;">
                            有何专长：
                        </td>
                        <td class="pricrTd" width="200px">{{this.form.studentType?this.form.studentType:"无"}}</td>
                        <td width="155px" style="background-color: #F6F7FB;">
                            爱好：
                        </td>
                        <td class="pricrTd" width="160px">{{this.form.hobby?this.form.hobby:"无"}}</td>
                         <td width="155px" style="background-color: #F6F7FB;">
                            毕业年月：
                        </td>
                        <td class="pricrTd" width="100px">{{this.form.graduationDate?this.form.graduationDate:"无"}}</td>
                    </tr>

                    <tr>
                        <td width="155px" style="background-color: #F6F7FB;">
                            毕业学校：
                        </td>
                        <td class="pricrTd" width="280px">{{this.form.graduationSchool?this.form.graduationSchool:"无"}}</td>
                        <td width="155px" style="background-color: #F6F7FB;">
                            是否管理员：
                        </td>
                        <td class="pricrTd" width="200px">{{this.form.adminSign?this.form.adminSign:"无"}}</td>
                        <td width="155px" style="background-color: #F6F7FB;">
                            积分：
                        </td>
                        <td class="pricrTd" width="160px">{{this.form.evaluateScore?this.form.evaluateScore:"无"}}</td>
                        <td width="155px" style="background-color: #F6F7FB;">
                            金币：
                        </td>
                        <td class="pricrTd" width="280px">{{this.form.goldCount?this.form.goldCount:"无"}}</td>
                    </tr>
                </table>

                <br/>
                <div style=" margin-bottom:10px;font-weight:bold;">通讯信息：</div>
                <table style="width: 100%; font-weight: 300;font-size: 14px;">
                    <tr>
                        <td width="155px" style="background-color: #F6F7FB;">
                            移动电话：
                        </td>
                        <td class="pricrTd" width="280px">{{this.form.mobile1?this.form.mobile1:"无"}}</td>
                         <td width="155px" style="background-color: #F6F7FB;">
                            办公室电话：
                        </td>
                        <td class="pricrTd" width="280px"> {{this.form.mobile2?this.form.mobile2:"无"}}</td>
                        <td width="155px" style="background-color: #F6F7FB;">
                            邮箱：
                        </td>
                        <td class="pricrTd" width="355px"> {{this.form.email?this.form.email:"无"}}</td>
                    </tr>
                </table>
                <!-- <br/> -->
                <!-- <div style=" margin-bottom:10px;font-weight:bold;">上下级关系：</div>
                <table style="width: 100%; font-weight: 300;font-size: 14px;">
                    <tr>
                        <td width="155px" style="background-color: #F6F7FB;">
                            直接上级：
                        </td>
                        <td class="pricrTd" width="280px"> {{this.form.directSuperiors?this.form.directSuperiors:"无"}}</td>
                        <td width="155px" >
                        </td>
                        <td class="pricrTd" width="280px"></td>
                        <td width="155px" >
                        </td>
                        <td class="pricrTd" width="100px"></td>
                        <td width="155px" ></td>
                        <td class="pricrTd" width="100px"></td>
                    
                    </tr>
                </table> -->
            </div>
 
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="visible=false">关 闭</el-button>
            </span>    
        </el-dialog>
    </div>
</template>
       
<script>
    import http from '../../../../common/http';

    export default {
        data(){
            return{
                visible: false,
                loading:false,
                form:{
                    id:"",
                    username:"",
                    name:"",
                    postId:"",
                    personType:"",
                    roleId:"",
                    deptId:"",
                    sex:"",
                    identityCard:"",
                    status:"",
                    studentType:"",
                    roomNumber:"",
                    faceImage:"",
                    postDescrible:"",
                    office:"",
                    expertise:"",
                    hobby:"",
                    graduationDate:"",
                    graduationSchool:"",
                    orderNum:"1",
                    mobile1:"",
                    mobile2:"",
                    email:"",
                    directSuperiors:"",
                    adminSign:false,
                    evaluateScore:"",
                    goldCount:"",
                },
                uploadForm:new FormData(),
                imageUrl: "",
                uploadUrl:"",
                deg:0,
                isUploadImage:false
            }
        },
        created:function () {
        },
        methods:{
            init(data){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                // console.log("详情："+JSON.stringify(data));
                this.form.id=data.id;
                this.form.username=data.username;
                this.form.name=data.name;
                // 人员类型（1-学生，2-教职）
                if(data.personType == 1){
                    this.form.personType="学生";
                }else if(data.personType == 2){
                    this.form.personType="教职";
                }
                this.form.postDescrible=data.postDescrible;
                //学生类型（0-其他，1-寄宿生，2-走读生，3-寄午生）
                if(data.studentType == 0){
                    this.form.studentType="其他";
                }else if(data.studentType == 1){
                    this.form.studentType="寄宿生";
                }else if(data.studentType == 2){
                    this.form.studentType="走读生";
                }else if(data.studentType == 3){
                    this.form.studentType="寄午生";
                }
                this.form.roomNumber=data.roomNumber;
                // 角色
                this.form.roleId=data.roleIdstrName;
                // 部门
                this.form.deptId=data.deptIdstrName;
                // 性别（1-男，2-女）
                if(data.sex == 1){
                    this.form.sex="男";
                }else if(data.sex == 2){
                    this.form.sex="女";
                }else{
                    this.form.sex="未知";
                }
                this.form.identityCard=data.identityCard;
                // 状态（1-正式、2-试用、3-临时）
                if(data.status == 1){
                    this.form.status="正式";
                }else if(data.status == 2){
                    this.form.status="试用";
                }else if(data.status == 3){
                    this.form.status="临时";
                }
                this.form.postId=data.postName;
                this.form.office=data.office;
                this.form.expertise=data.expertise;
                this.form.hobby=data.hobby;
                this.form.graduationDate=data.graduationDate;
                this.form.graduationSchool=data.graduationSchool;
                // 是否管理员（1-是，2-否）
                if(data.adminSign == 1){
                    this.form.adminSign="是";
                }else if(data.adminSign == 2){
                    this.form.adminSign="否";
                }
                this.form.orderNum=data.orderNum;
                this.form.mobile1=data.mobile1;
                this.form.mobile2=data.mobile2;
                this.form.email=data.email;
                this.form.directSuperiors=data.directSuperiorsName;
                this.form.faceImage=data.faceImage;
                // console.log("图片："+this.form.faceImage);
                // 初始地址
                this.uploadForm=new FormData(); 
                this.uploadUrl=this.nameUploadImageUrl;
                this.imageUrl=data.faceImage;
                // 是否二级平台，如果是二级平台上传图片不能用
                let platform =JSON.parse(sessionStorage.getItem('platforminfo')).platform;
                if(platform == 'twoPlatform'){
                    this.isUploadImage=false;
                }

                this.form.evaluateScore=data.evaluateScore;
                this.form.goldCount=data.goldCount;

            },
            dialogClose(done){
                done();
                this.$reload;
            },
            handleAvatarSuccess(res, file) {
                this.imageUrl = URL.createObjectURL(file.raw);
            },
            revertAvatarPreview(prevImageUrl, prevFaceImage) {
                let cur = this.imageUrl;
                if (cur && typeof cur === 'string' && cur.indexOf('blob:') === 0) {
                    try { URL.revokeObjectURL(cur); } catch (e) {}
                }
                this.imageUrl = prevImageUrl || '';
                this.form.faceImage = prevFaceImage == null ? '' : prevFaceImage;
            },
            beforeAvatarUpload(file) {
                let isJPG = (file.type == 'image/jpeg');
                let isLt2M = file.size / 1024 / 1024 < 8;

                if (!isJPG) {
                    this.$message.error('上传头像图片只能是 JPG 格式!');
                }
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 8MB!');
                }
                if(isJPG && isLt2M){
                    let prevImageUrl = this.imageUrl;
                    let prevFaceImage = this.form.faceImage;
                    this.uploadForm=new FormData(); 
                    // 上传文件
                    this.uploadForm.append('file', file);
                    this.$axios.post(this.nameUploadImageUrl, this.uploadForm).then((res) => {
                        if(res.data.status == 200){
                           // console.log("临时文件目录："+res.data.data.localFile);
                           this.form.faceImage=res.data.data.localFile;
                           // 提交图片都后台，并验证该图片是否正常
                           this.loading=true;
                           let url = this.userUpdateImageUrl;
                           let data = {
                                id:this.form.id,
                                faceImage:this.form.faceImage,
                           }; 
                           // console.log("提交列表:"+JSON.stringify(data))
                           this.apiPost(url, data).then((res) => {
                                // console.log("响应列表:"+JSON.stringify(res))
                                if(res.status == 200){
                                    this.$commonFn.showTip(res.message,1);
                                    this.$parent.getData();
                                }else{
                                    this.$commonFn.showTip(res.message, 3);
                                    this.revertAvatarPreview(prevImageUrl, prevFaceImage);
                                }
                                this.loading=false;
                            }, (err) => {
                                console.log(JSON.stringify(err));
                                this.$commonFn.showTip(err.message, 3);
                                this.revertAvatarPreview(prevImageUrl, prevFaceImage);
                                this.loading=false;
                            });
                        }else{
                            this.$commonFn.showTip(res.data.message, 3);
                            this.revertAvatarPreview(prevImageUrl, prevFaceImage);
                        }
                    }, (err) => {
                        console.log(err)
                        this.$commonFn.showTip("网络繁忙，请稍后重试，响应码("+err.response.status+")", 3);
                        this.revertAvatarPreview(prevImageUrl, prevFaceImage);
                    });
                }else{
                    return false;
                }
            },
            // 旋转
            rotate(){
                this.deg += 90;
                if(this.deg >= 360){
                    this.deg = 0
                }
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
     table{
        border: 0px solid rgb(216,220,228);
        border-collapse: collapse;
    }

    td{
        font-weight: 400;
        text-align: right;
        border: 0px solid rgb(216,220,228);
        height:38px;
    }

    .pricrTd{
        font-weight: 400 !important;
        text-align: left !important;
        padding-left: 10px;
    }
    .avatar {
        width: 130px;
        height: 108px;
        display: block;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/sys/user/UserDetails.vue